import { Stack } from "@mui/material";
import Chip from "components/Chip";
import { Icon, type IconName } from "components/Icon";
import { useTranslation } from "react-i18next";

import type { EnergyAnalysisDimension } from "../model/types";

import { ENERGY_ANALYSIS_DIMENSION } from "../model/constants";
import { EnergyAnalysisSettingsGroup } from "./EnergyAnalysisSettingsGroup";

const DIMENSIONS: { iconName: IconName; labelKey: EnergyAnalysisDimension; name: EnergyAnalysisDimension }[] = [
  { iconName: "BuildingTypeIcon", labelKey: "useType", name: ENERGY_ANALYSIS_DIMENSION.useType },
  { iconName: "Energy", labelKey: "utility", name: ENERGY_ANALYSIS_DIMENSION.utility },
  { iconName: "GridIcon", labelKey: "mix", name: ENERGY_ANALYSIS_DIMENSION.mix },
  { iconName: "Piechart", labelKey: "joint", name: ENERGY_ANALYSIS_DIMENSION.joint },
  { iconName: "GridIcon", labelKey: "corrections", name: ENERGY_ANALYSIS_DIMENSION.corrections },
];

type EnergyAnalysisDimensionControlProps = {
  dimension: EnergyAnalysisDimension;
  onChange: (dimension: EnergyAnalysisDimension) => void;
};

export const EnergyAnalysisDimensionControl = ({ dimension, onChange }: EnergyAnalysisDimensionControlProps) => {
  const { t } = useTranslation();
  return (
    <EnergyAnalysisSettingsGroup>
      <Stack className="gap-2">
        {DIMENSIONS.map((item) => (
          <Chip isOn={item.name === dimension} key={item.name} onClick={() => onChange(item.name)}>
            <Stack className="items-center gap-1">
              <Icon iconName={item.iconName} size="sm" />
              <span>{t(`BuildingProfile.energyAnalysis.tabs.${item.labelKey}`)}</span>
            </Stack>
          </Chip>
        ))}
      </Stack>
    </EnergyAnalysisSettingsGroup>
  );
};
